var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Alert',{attrs:{"is-show":_vm.alert.state.active,"message":_vm.alert.state.message,"variant":_vm.alert.state.variant,"is-closable":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }